import { useState } from "react";
import { Carousel, Button } from "react-bootstrap";

function Banner(props) {
  const [isPaused, setIsPaused] = useState(false);

  return (
    <div style={{ position: "relative" }}>

      {/* Botón Play / Pause superpuesto */}
      <div
        style={{
          position: "absolute",
          top: "15px",
          left: "15px",
          zIndex: 10
        }}
      >
        <Button
          variant={isPaused ? "primary" : "warning"}
          onClick={() => setIsPaused(!isPaused)}
          style={{
            borderRadius: "50%",
            width: "45px",
            height: "45px",
            opacity: 0.85
          }}
        >
          {isPaused ? "▶" : "⏸"}
        </Button>
      </div>

      <Carousel
        variant="dark"
        interval={isPaused ? null : 2000}
        pause={false}
      >
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/imagenes/banner/fotoUtn.jpeg"
            alt="UTN La Plata"
          />
          <Carousel.Caption className="carruselshadow">
            <h3 style={{ color: "white" }}>
              Somos parte de la UTN La Plata
            </h3>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/imagenes/banner/equipoLina.jpeg"
            alt="Equipo"
          />
          <Carousel.Caption className="carruselshadow">
            <h3 style={{ color: "white" }}>
              Somos un equipo decidido a mejorar la calidad de vida de las personas
            </h3>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/imagenes/banner/fono-paciente2.jpg"
            alt="Fonoaudiologo"
          />
          <Carousel.Caption className="carruselshadow">
            <h3 style={{ color: "white" }}>
              Brindamos apoyo con las rehabilitaciones
            </h3>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/imagenes/banner/gamificacion.jpg"
            alt="Gamificacion"
          />
          <Carousel.Caption className="carruselshadow">
            <h3 style={{ color: "black" }}>
              Llevamos la rehabilitación a un entorno lúdico y entretenido
            </h3>
          </Carousel.Caption>
        </Carousel.Item>

      </Carousel>
    </div>
  );
}

export default Banner;
